export default __webpack_public_path__ + "static/media/8b.968d34ca.png";